var currentColor = 1;
setInterval(function () {
    currentColor = Math.floor(Math.random() * 8) + 1;
}, 1000);

function drawEvent(event) {
    for (i = 1; i < 9; i++) {
        this.classList.remove("active-" + i);
    }
    this.classList.add("active-" + currentColor);
    let this_el = this;
    setTimeout(
        function (this_el) {
            for (i = 1; i < 9; i++) {
                this_el.classList.remove("active-" + i);
            }
        },
        2000,
        this_el
    );
}

document.addEventListener("DOMContentLoaded", function() {
    const logo = document.getElementById("animation__logo");
    const logo_paths = document.querySelectorAll(".uuid-51f8e308-62fb-47d4-b372-55ef6ea1f4f6,.uuid-695dfa3d-db2e-4ee0-a570-6fcfc0115ff5,.uuid-7b2c1d52-5aa8-4362-9bc0-ab828564fb74, .uuid-695dfa3d-db2e-4ee0-a570-6fcfc0115ff5, .uuid-695dfa3d-db2e-4ee0-a570-6fcfc0115ff5,.uuid-7b2c1d52-5aa8-4362-9bc0-ab828564fb74");
    //console.log(logo_paths.length);
    for (var i = 0; i < logo_paths.length; i++) {
        logo_paths[i].addEventListener(
            "mouseover",
            function (event) {
                //console.log('called on hover'); //just to make sure the function is getting called
                drawEvent.call(this, event);
            },
            false
        );
    }
});